export const PRODUCT_PACKETS_LOADING = 'PRODUCT_PACKETS_LOADING';
export const PRODUCT_PACKETS_SUCCESS = 'PRODUCT_PACKETS_SUCCESS';
export const PRODUCT_PACKETS_ERROR = 'PRODUCT_PACKETS_ERROR';
export const PRODUCT_PACKETS_CLEAR = 'PRODUCT_PACKETS_CLEAR';
